import { render, staticRenderFns } from "./Insert.vue?vue&type=template&id=7d889242&scoped=true&"
import script from "./Insert.vue?vue&type=script&lang=js&"
export * from "./Insert.vue?vue&type=script&lang=js&"
import style0 from "./Insert.vue?vue&type=style&index=0&id=7d889242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d889242",
  null
  
)

export default component.exports